import {sortBy} from 'ramda';

import i18n from '@dms/i18n';
import {useCodeList} from '@dms/shared';

import {SaleVehicle} from '../../core/types/SaleVehicle';
import {Field} from './primitives/Field';

export function SourceSelect() {
  const [vehicleSourceCodes] = useCodeList('vehicle_source');
  const vehicleSourceOptions =
    sortBy((code) => code.priority, vehicleSourceCodes ?? []).map((source) => ({
      value: source.codeId,
      label: source.name,
    })) ?? [];

  return (
    <Field<SaleVehicle, 'choice'>
      type="choice"
      options={vehicleSourceOptions}
      name="vehicleSourceCodeId"
      label={i18n.t('entity.vehicle.labels.vehicleSource')}
    />
  );
}
